import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var INITIAL_STATE = {
  spaces: [],
  loading: true,
  error: null
};
export var actions = {
  SPACES: function SPACES(_, _ref) {
    var spaces = _ref.spaces;
    return {
      spaces: spaces || [],
      error: null,
      loading: false
    };
  },
  ERROR: function ERROR(state, _ref2) {
    var error = _ref2.error;
    return _objectSpread({}, state, {
      loading: false,
      error: error
    });
  },
  LOADING: function LOADING(state, _ref3) {
    var loading = _ref3.loading;
    return _objectSpread({}, state, {
      loading: loading !== undefined ? loading : !state.loading
    });
  }
};
export var spacesReducer = function spacesReducer(state, action) {
  return actions[action.type](state, action);
};
export var sanitizeSpaces = function sanitizeSpaces(spaces) {
  // Normalize space pairs ( [{ name, value }] => { name: value } )
  var pairFields = ['images', 'metadata', 'colors', 'icons', 'mapping'];
  return spaces.reduce(function (accum, spc) {
    pairFields.forEach(function (field) {
      if (spc[field] && Array.isArray(spc[field])) {
        spc[field] = spc[field].reduce(function (_accum, _ref4) {
          var name = _ref4.name,
              value = _ref4.value;
          _accum[name] = value;
          return _accum;
        }, {});
      }
    });
    accum.push(spc);
    return accum;
  }, []);
};
export var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};